import ResizeObserver from "resize-observer-polyfill";
import React, { Suspense, useEffect } from 'react';
import { Text } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { Provider } from 'react-redux';
import { store, persistor } from "./store/store";
import { PersistGate } from 'redux-persist/integration/react';

import *  as screens from './screens/index';

// const screens = React.lazy(() => import('./screens/index'));
const MyTheme = {
  dark: false,
  colors: {
    primary: 'rgb(254, 255, 255)',
    background: 'rgb(255, 255, 255)',
    card: 'rgb(255, 255, 255)',
    text: 'rgb(28, 28, 30)',
    border: 'rgb(199, 199, 204)',
    notification: 'rgb(255, 69, 58)',
  },
};

window.ResizeObserver = ResizeObserver;
// const CommonPopUp = React.lazy(() => import('./utils/widgets/CommonPopUp'));
// const CommonLoaderComponent = React.lazy(() => import('./utils/widgets/CommonLoaderComponent'));
// const CommonAlertModal = React.lazy(() => import('./utils/widgets/CommonAlertModal'));

import CommonLoaderComponent from "./utils/widgets/CommonLoaderComponent";

const Stack = createStackNavigator();

import {
  useFonts,
  Roboto_400Regular,
  Roboto_500Medium,
} from '@expo-google-fonts/roboto';
import { ScreenRoute } from "./utils/constants/ScreenRouteConstant";

import {
  Lato_400Regular,
  Lato_900Black,
  Lato_700Bold
} from '@expo-google-fonts/lato';
import { onAppLoad } from "./utils/services/webapp-services/OnAppLoadInitializer";
import { getBaseHref } from "./utils/services/CommonUtils";

// import * as Sentry from 'sentry-expo';

// Sentry.init({
//   dsn: 'https://d9659e41d7a1419daa6edd71101aae0a@o213716.ingest.sentry.io/6082014',
//   enableInExpoDevelopment: true,
//   debug: true, // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
// });

// // Access any @sentry/react-native exports via:
// Sentry.Native

// // Access any @sentry/browser exports via:
// Sentry.Browser

const App = (props) => {

  useFonts({
    Roboto_400Regular,
    Roboto_500Medium,
    Lato_400Regular,
    Lato_900Black,
    Lato_700Bold
  });
  // const [showPopUp, setModalVisible] = useState(false);
  // state: any = {
  //   navigation: '',
  //   showPopUp: false,
  // }

  // constructor(props) {
  //   super(props);
  // }
  // handleBackButton() {
  //   console.log('rk back pressed phone');

  //   BackHandler.exitApp();
  // }

  const getPathFromState = (props: any, options?: any) => {
    return getBaseHref() + '/' + props.routes[props.routes.length - 1].name;
  }

  const getPharmacyProfilePageTitle = () => {
    if (localStorage.getItem('storeProfileLoaded') && localStorage.getItem('profileDeeplinkData')) {
      let profileDeeplinkData: any = localStorage.getItem('profileDeeplinkData');
      profileDeeplinkData = JSON.parse(profileDeeplinkData);
      if (profileDeeplinkData?.pharmacyName) {
        return profileDeeplinkData?.pharmacyName;
      } else return 'Order from store'
    } else return 'Order from store'
  }

  // enableFreeze(true)

  useEffect(() => { onAppLoad() })

  return (
    <div>
      <Suspense fallback={<Text> Loading...</Text>}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <NavigationContainer theme={MyTheme}
              linking={{
                enabled: true, prefixes: [],
                getPathFromState: getPathFromState
              }}>
              <CommonLoaderComponent />
              <Stack.Navigator initialRouteName={ScreenRoute.splash}>
                {/* SplashScreen which will come once for 5 Seconds */}
                <Stack.Screen
                  name={ScreenRoute.splash}
                  component={screens.SplashScreen}
                  // Hiding header for Splash Screen
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />
                <Stack.Screen
                  name={ScreenRoute.tab_controller_screen}
                  component={screens.TabControllerScreen}
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />
                <Stack.Screen
                  name={ScreenRoute.dashboard_screen}
                  component={screens.DashboardScreen}
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />
                <Stack.Screen
                  name={ScreenRoute.cart}
                  component={screens.TabControllerScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.orders}
                  component={screens.TabControllerScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.profile}
                  component={screens.TabControllerScreen}
                  options={{ headerShown: false }}
                />

                <Stack.Screen
                  name={ScreenRoute.login}
                  component={screens.LoginScreen}
                  // Hiding header for Splash Screen
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />
                <Stack.Screen
                  name={ScreenRoute.complete_profile}
                  component={screens.CompleteProfile}
                  // Hiding header for Splash Screen
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />
                <Stack.Screen
                  name={ScreenRoute.otp}
                  component={screens.OTPScreen}
                  // Hiding header for Splash Screen
                  options={{ headerShown: false, title: window.DEFAULT_TITLE }}
                />

                <Stack.Screen
                  name={ScreenRoute.profile_screen}
                  component={screens.ProfileDetails}
                  options={{ headerShown: false, title: 'Family Members' }}
                />
                <Stack.Screen
                  name={ScreenRoute.upsert_family_data}
                  component={screens.AddUpdateMember}
                  options={{ headerShown: false, title: 'Add New Member' }}
                />
                <Stack.Screen
                  name={ScreenRoute.acs_plans}
                  component={screens.PrePurchaseAayuCard}
                  options={{ headerShown: false, title: 'Aayu Card Plans' }}
                />
                <Stack.Screen
                  name={ScreenRoute.acs_quiz}
                  component={screens.AayuCardQuiz}
                  options={{ headerShown: false, title: 'Plan Recommendation' }}
                />
                <Stack.Screen
                  name={ScreenRoute.acs_plan_recommender}
                  component={screens.AayuCardRecommend}
                  options={{ headerShown: false, title: 'Plan Recommendation' }}
                />
                <Stack.Screen
                  name={ScreenRoute.acs_current_plan}
                  component={screens.PostPurchaseAayu}
                  options={{ headerShown: false, title: "Your Aayu Card Plan" }}
                />
                <Stack.Screen
                  name={ScreenRoute.payment_online}
                  component={screens.ServicePayment}
                  options={{ headerShown: false, title: 'AAYU CARD PAYMENT' }}
                />
                <Stack.Screen
                  name={ScreenRoute.payment_acs}
                  component={screens.PaymentWithSubscription}
                  options={{ headerShown: false, title: 'Consultation Payment' }}
                />
                <Stack.Screen
                  name={ScreenRoute.custom_checkout}
                  component={screens.CustomCheckout}
                  options={{ headerShown: false, title: 'Payment methods' }}
                />
                <Stack.Screen
                  name={ScreenRoute.choose_acs_plan}
                  component={screens.AayuCardList}
                  options={{ headerShown: false, title: "Select Plan" }}
                />
                <Stack.Screen
                  name={ScreenRoute.econsult_success}
                  component={screens.EconsultCreated}
                  options={{ headerShown: false, title: "Consultation" }}
                />
                <Stack.Screen
                  name={ScreenRoute.member_selection}
                  component={screens.MemberSelection}
                  options={{ headerShown: false, title: "Select Family Member" }}
                />
                <Stack.Screen
                  name={ScreenRoute.econsult_start}
                  component={screens.FirstConsultation}
                  options={{ headerShown: false, title: "Consultation" }}
                />
                <Stack.Screen
                  name={ScreenRoute.questionaire_screen}
                  component={screens.QuestionaireScreen}
                  options={{ headerShown: false, title: "Select Family Member" }}
                />
                <Stack.Screen
                  name={ScreenRoute.problem_selection}
                  component={screens.CategorySelection}
                  options={{ headerShown: false, title: "Select Your Problem" }}
                />
                <Stack.Screen
                  name={ScreenRoute.list_user_services}
                  component={screens.ActivityList}
                  options={{ headerShown: false, title: 'Consultations' }}
                />
                <Stack.Screen
                  name={ScreenRoute.list_orders}
                  component={screens.OrderList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.econsult_details}
                  component={screens.SingleConsultView}
                  options={{ headerShown: false, title: 'Consultations' }}
                />
                <Stack.Screen
                  name={ScreenRoute.review_answer}
                  component={screens.ReviewAnswers}
                  options={{ headerShown: false, title: 'Consultation Questions' }}
                />
                {/* <Stack.Screen
                  name='product_list'
                  component={screens.ProductList}
                  options={{ headerShown: false, title: "Products" }}
                />
                <Stack.Screen
                  name='product_details'
                  component={screens.ProductDetails}
                  options={{ headerShown: false, title: "Product Details" }}
                /> */}
                <Stack.Screen
                  name={ScreenRoute.list_member}
                  component={screens.MemberList}
                  options={{ headerShown: false, title: "Family Members" }}
                />
                <Stack.Screen
                  name={ScreenRoute.transaction_history}
                  component={screens.TransactionHistory}
                  options={{ headerShown: false, title: "Transactions" }}
                />
                <Stack.Screen
                  name={ScreenRoute.search_locality}
                  component={screens.SearchLocality}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.review_oms_order}
                  component={screens.ReviewOrder}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.oms_detect_user_location}
                  component={screens.FetchOMSLocation}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name='select_type'
                  component={screens.SelectType}
                />
                <Stack.Screen
                  name='search_by_text'
                  component={screens.SearchText}
                />
                <Stack.Screen
                  name={ScreenRoute.list_pharmacy}
                  component={screens.PharmacyList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.selected_pharmacy}
                  component={screens.SelectedPharmacy}
                  options={{ headerShown: false, title: getPharmacyProfilePageTitle() }}
                />
                <Stack.Screen
                  name={ScreenRoute.site_store_profile}
                  component={screens.SelectedPharmacy}
                  options={{ headerShown: false, title: getPharmacyProfilePageTitle() }}
                />
                <Stack.Screen
                  name={ScreenRoute.search_medicine}
                  component={screens.SearchMedicineComponent}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.product_categories}
                  component={screens.InventoryCategory}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.search_deals}
                  component={screens.SearchDeals}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.selected_deals}
                  component={screens.SelectedDealView}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.view_order_summary}
                  component={screens.OrderSummary}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.oms_message_view}
                  component={screens.MessageView}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.view_order_details}
                  component={screens.OrderDetails}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.order_successful}
                  component={screens.OrderSuccess}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.wallet_netbanking_mods_list}
                  component={screens.WalletNetBankingModesList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.oms_offers}
                  component={screens.OmsOffers}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={`${ScreenRoute.card_input}`}
                  component={screens.EnterDebitCreditDetails}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.payment_success_failed}
                  component={screens.PaymentSuccessOrFailed}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.notification_list}
                  component={screens.NotificationList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.offers_list}
                  component={screens.OffersList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.selected_offer}
                  component={screens.SelectedOfferView}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.rewards_screen}
                  component={screens.RewardsScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.address_list}
                  component={screens.UserAddressList}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.upsert_user_address}
                  component={screens.UpsertUserAddress}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.chemist_store_profile_view}
                  component={screens.ChemistStoreProfile}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name={ScreenRoute.images_preview}
                  component={screens.ImagesPreview}
                  options={{ headerShown: false }}
                />
              </Stack.Navigator>
            </NavigationContainer>
          </PersistGate>
        </Provider >
      </Suspense>
    </div>
  );
}

export default App;

